(function ($) {
  var lastScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
  let ticking = false;

  function scrolled() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var scrollDirection = '';

    // iOS Fix: Negatives Scrollen (Bounce-Effekt) abfangen, sonst gibt es Fehler bei der Richtung
    if (scrollTop < 0) {
      scrollTop = 0;
    }

    if (scrollTop > lastScrollPosition) {
      scrollDirection = 'down';
    } else if (scrollTop < lastScrollPosition) {
      scrollDirection = 'up';
    }

    lastScrollPosition = scrollTop;

    $(document).trigger('swr:scroll:scrolled', {
      position: scrollTop,
      direction: scrollDirection
    });

    ticking = false;
  }

  /**
   * Event Listener
   * Nutzt 'passive: true' für bessere Performance auf Mobile Devices
   */
  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(scrolled);
      ticking = true;
    }
  }, { passive: true });
}(window.jQuery));


